import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from '../../../services/sx-error.service';
import { MenuItem, SystemContent } from '@model';
import { Text } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getMenu(): Observable<MenuItem[]> {
    return this.http
      .get<MenuItem[]>(`${environment.apiEndpoint}/appsettings/Menu`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getSystemContent(): Observable<SystemContent> {
    return this.http
      .get<SystemContent>(`${environment.apiEndpoint}/appsettings/system-content`)
      .pipe(catchError(error => this.sxErrorService.handleError(error)));
  }

  getRtmTrackingScript(): Observable<any> {
    return this.http
      .get<any>(`${environment.apiEndpoint}/appsettings/RtmTrackingScript`)
      .pipe(catchError(error => this.sxErrorService.handleError(error)));
  }
}
